"use client";
import { jsxs as C, jsx as n } from "react/jsx-runtime";
import { useState as L, useRef as W, useEffect as I } from "react";
const k = ({
  tooltipStyle: T,
  icon: $ = "icon-help",
  title: d,
  titlePosition: N,
  text: u,
  textPosition: S,
  imageSrc: h,
  imageWidth: y,
  imageHeight: B,
  imageAlt: M
}) => {
  const [f, E] = L(null), g = W(null);
  I(() => {
    const t = (H) => {
      var b, v;
      const i = H.currentTarget;
      if (!i)
        return;
      const e = i.getBoundingClientRect(), w = i.querySelector(".tooltip-box");
      if (!w)
        return;
      const r = w.getBoundingClientRect(), P = ((b = window.visualViewport) == null ? void 0 : b.width) ?? window.innerWidth, R = ((v = window.visualViewport) == null ? void 0 : v.height) ?? window.innerHeight, a = 28, s = e.x, l = Math.abs(
        e.x + e.width - P
      ), j = e.y, A = Math.abs(
        e.y + e.height - R
      ), x = r.width / 2 + a;
      let c = "center";
      s > l ? x > l && (c = "left") : s < l && x > s && (c = "right");
      let p = "top";
      j < r.height + a && (p = "bottom"), A < r.height + a && (p = "top"), E(`${p}-${c}`);
    }, o = g.current;
    if (o)
      return o.addEventListener("pointerover", t), () => {
        o.removeEventListener("pointerover", t);
      };
  }, []);
  const m = `tooltip-${Math.random() * 1e3}`;
  return /* @__PURE__ */ C("span", { className: `tooltip-container ${T}`, ref: g, children: [
    /* @__PURE__ */ n(
      "button",
      {
        className: `tooltip-icon ${$}`,
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "aria-controls": m,
        onClick: (t) => {
          t.preventDefault(), t.stopPropagation();
          const o = t.currentTarget.getAttribute("aria-expanded") === "true";
          t.currentTarget.setAttribute("aria-expanded", String(!o));
        },
        onBlur: (t) => {
          t.currentTarget.setAttribute("aria-expanded", "false");
        },
        children: /* @__PURE__ */ n("span", { className: "screen-readers-only", children: "Mostrar ajuda" })
      }
    ),
    /* @__PURE__ */ C(
      "div",
      {
        role: "status",
        className: `tooltip-box${f ? " " + f : ""}`,
        id: m,
        children: [
          d ? /* @__PURE__ */ n("h6", { className: `${N}`, children: d }) : null,
          u ? /* @__PURE__ */ n(
            "span",
            {
              className: `${S}`,
              dangerouslySetInnerHTML: { __html: u }
            }
          ) : null,
          h ? /* @__PURE__ */ n(
            "img",
            {
              src: h,
              width: y,
              height: B,
              alt: M
            }
          ) : null
        ]
      }
    )
  ] });
};
export {
  k as Tooltip
};
